// Catalog.ID Client — Publication Badge Component
// ============================================================================
// Visual indicator for a claim's publication (operator-review) state.
// Companion to certificate-badge (validation state); reuses its styles.

import { createElement } from '@catalog-shell';
import { PUBLICATION_STATUS_LABELS, type PublicationStatus } from './publication-status';

export interface PublicationBadgeConfig {
    status: PublicationStatus;
    /** Operator's reason when status is 'rejected'; shown as the badge tooltip. */
    rejectionReason?: string | null;
}

const STATUS_STYLES: Record<PublicationStatus, { bg: string; fg: string; icon: string }> = {
    none:      { bg: 'rgba(128,128,128,0.15)', fg: '#888', icon: '○' },
    // Amber, matching CPR's "Pending review" — see publication-status.ts.
    pending:   { bg: 'rgba(220,150,50,0.15)', fg: '#ea4', icon: '◌' },
    published: { bg: 'rgba(80,200,80,0.15)', fg: '#5c5', icon: '✓' },
    rejected:  { bg: 'rgba(220,50,50,0.15)', fg: '#e55', icon: '✕' },
};

export function createPublicationBadge(config: PublicationBadgeConfig): HTMLElement {
    const style = STATUS_STYLES[config.status];

    const badge = createElement('span', {
        className: 'cid-cert-badge',
        style: { background: style.bg, color: style.fg, border: `1px solid ${style.fg}33` },
    });

    badge.appendChild(createElement('span', {
        className: 'cid-cert-badge-icon',
        textContent: style.icon,
    }));

    badge.appendChild(createElement('span', {
        className: 'cid-cert-badge-label',
        textContent: PUBLICATION_STATUS_LABELS[config.status],
    }));

    if (config.status === 'rejected' && config.rejectionReason) {
        badge.title = `Rejected: ${config.rejectionReason}`;
    }

    return badge;
}
